import { useRef, useState, useMemo } from "react"
import GroupConditionType from "../types/GroupCondition"
import { transformGroupConditionToPayload } from "../util/groupConditionTransform"

interface ValidateCriteriaReturnType {
    isValidCriteria: boolean
    criteria: string
    isAlive: boolean
}
export default function useValidateCriteriaForm(offerService: any) {
    const networkCallCounter = useRef(0)

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const validateForm = async (offerFormEId: string, groupConditions: GroupConditionType[]): Promise<ValidateCriteriaReturnType> => {
        networkCallCounter.current++
        const myNumber = networkCallCounter.current

        setLoading(true)
        setError('')

        try {
            const response = await validateCriteriaForm({ offerService, offerFormEId, groupConditions })

            if (myNumber === networkCallCounter.current) {
                setLoading(false)

                if (response.status === 'error') {
                    setError('An error occurred while validating criteria')
                    console.error('An error occurred while validating criteria data', response)
                    return {
                        isValidCriteria: false,
                        criteria: '',
                        isAlive: true,
                    }
                } else if (response.status === 'success') {
                    return {
                        isValidCriteria: response.isValidCriteria,
                        criteria: response.criteria,
                        isAlive: true,
                    }
                }
            } else {
                return {
                    isValidCriteria: false,
                    criteria: '',
                    isAlive: false,
                }
            }
        } catch (err) {
            if (myNumber === networkCallCounter.current) {
                setError('An error occurred while validating the criteria form')
                console.error('An error occurred while validating criteria data', err.toString())
                setLoading(false)
                return {
                    isValidCriteria: false,
                    criteria: '',
                    isAlive: true,
                }
            } else {
                return {
                    isValidCriteria: false,
                    criteria: '',
                    isAlive: false,
                }
            }
        }
    }

    return useMemo(() => ({
        loading,
        error,
        validateForm,
    }), [
        loading,
        error,
        validateForm,
    ])
}

interface FetchOptions {
    offerService: any
    offerFormEId: string
    groupConditions: GroupConditionType[]
}
type FetchReturnValue = Promise<{
    status: 'error' | 'success'
    httpCode: number | null
    message: string
    stack: any
    isValidCriteria: boolean
    criteria: string
}>
const validateCriteriaForm = ({ offerService, offerFormEId, groupConditions }: FetchOptions): FetchReturnValue => {
    return new Promise(function (resolve, reject) {
        const transformedData = transformGroupConditionToPayload(groupConditions)

        offerService.validateCriteriaForm(JSON.stringify({
            offerFormEId,
            conditionGroupList: transformedData,
        }))
            .then((response: any) => {
                resolve({
                    status: 'success',
                    httpCode: response.status,
                    message: '',
                    stack: null,
                    isValidCriteria: response.data.isValidCriteria || false,
                    criteria: response.data.criteria || '',
                })
            })
            .catch((err: any) => {
                reject({
                    status: 'error',
                    httpCode: null,
                    message: 'Failed to post results',
                    stack: err.toString(),
                    isValidCriteria: false,
                    criteria: '',
                })
            })
    })
}
